import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.string

class StringEditor extends BaseEditor {
    constructor (options, defaults) {
        super(options, defaults)
        this.isBasic = options.jsoneditor.options.isBasic || false
        if (this.isBasic) {
            if (this.key.startsWith('$_')) {
                this.options.hidden = false
            } else if (this.key.startsWith('$x')) {
                this.schema.readOnly = true
                this.options.hidden = true
            } else {
                this.options.hidden = true
            }
        }
    }
}

export default StringEditor